import {
  findAllJobPostDto,
  findAllJobPostResponse,
  findJobDescriptionByIdResponse,
  findAllJobApplicationResponse,
} from "../Interface/Index";
import apiClient from "./api-client.service";

export default class JobDescriptionService {
  private static instance: JobDescriptionService;
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  static getInstance(): JobDescriptionService {
    if (!JobDescriptionService.instance) {
      JobDescriptionService.instance = new JobDescriptionService();
    }
    return JobDescriptionService.instance;
  }

  async findAllJobPostWithFiletrsAndPositionCounts(
    payload: findAllJobPostDto,
  ): Promise<findAllJobPostResponse> {
    const { page, limit, position, searchQuery } = payload;
    try {
      let url = `${this.APIBaseUrl}/job-description`;

      if (page && limit) {
        url += `?page=${page}&limit=${limit}`;
      }

      if (position && position.length > 0) {
        url += `&positions=${position.join(",")}`;
      }

      if (searchQuery) {
        url += `&search=${searchQuery}`;
      }

      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching job posts:", error);
      throw error;
    }
  }

  async findJobDescriptionById(
    id: string,
  ): Promise<findJobDescriptionByIdResponse> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/job-description/${id}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching job description by id:", error);
      throw new Error("Failed to fetch job description");
    }
  }

  async findJobDescriptionBySlug(slug: string, orgId: string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/job-description/slug/${slug}/${orgId}`,
      );
      return response.data;
    } catch (error: any) {
      console.error("Error fetching job description by slug:", error);
      throw new Error("Failed to fetch job description by slug");
    }
  }

  async getAllJobApplicationsOfTheUser(
    payload: findAllJobPostDto,
  ): Promise<findAllJobApplicationResponse> {
    const { page, limit, position, searchQuery } = payload;
    try {
      let url = `${this.APIBaseUrl}/job-description/job-applications/all`;

      if (page && limit) {
        url += `?page=${page}&limit=${limit}`;
      }

      if (position && position.length > 0) {
        url += `&positions=${position.join(",")}`;
      }

      if (searchQuery) {
        url += `&search=${searchQuery}`;
      }

      const response = await apiClient.get(url);
      return response.data;
    } catch (error: any) {
      console.error(
        "Error while finding all job application of the user",
        error,
      );
      throw error;
    }
  }
}
